import { navigate } from "svelte-routing";
import { get } from "svelte/store";
import { api } from "../../services/helpers";
import { getMasterData } from "../../services/profile";
import { invalidateLookupCaches } from "../../services/lookupCache";
import {
	email as emailStore,
	errorMessage,
	loading,
	masterData,
	refreshToken,
	resetAllStores,
	successMessage,
	token,
	userName,
	userRole,
	userRoleName,
} from "../store";
import { PERMISSIONS, isWshopOnly } from "../../config/permissions";

export const doLogout = async () => {
	localStorage.removeItem("token");
	localStorage.removeItem("refreshToken");
	localStorage.removeItem("userRole");
	localStorage.removeItem("userName");
	localStorage.removeItem("damageReviewedData");

	Object.keys(localStorage).forEach((key) => {
		if (key.startsWith("caseInvestigate")) {
			localStorage.removeItem(key);
		}
	});

	resetAllStores();
	invalidateLookupCaches();
	navigate("/login");
};

export const doLogin = async ({ email, password }) => {
	try {
		let logToken;
		loading.set(true);
		errorMessage.set("");
		const res = await api("/v1/auth/login", "User", "POST", {
			email,
			password,
		});

		if (res.status === 200) {
			token.set(res.data.accessToken);
			logToken = get(token);

			const permissions = res.data.profile.permissions;
			userRole.set(permissions);
			userRoleName.set(res.data.profile.role);
			localStorage.setItem(
				"userName",
				res.data.profile.firstName + " " + res.data.profile.lastName
			);

			userName.set(
				res.data.profile.firstName + " " + res.data.profile.lastName
			);
			emailStore.set(res.data.profile.email);
			loading.set(false);
			if (logToken) {
				localStorage.setItem("token", logToken);
				const resultMasterData = await getMasterData();
				masterData.set(resultMasterData.data);
				navigate(
					isWshopOnly(permissions)
						? "/maintenance-repair"
						: "/dashboard"
				);
			}
		} else {
			errorMessage.set(res.data.error_msg);
			loading.set(false);
		}
	} catch (err) {
		loading.set(false);
		if (err.response.data.code) {
			errorMessage.set(
				`Error ${err.response.data.code}: ${err.response.data.message}`
			);
		} else {
			errorMessage.set(err.message);
		}
	}
};

// QA bypass (FRNT-5926): logs in as a workshop-only user (permission 14)
// without calling the login API, so the wshop-only flow can be tested
// before a real backend account with that permission exists.
export const doLoginAsWorkshop = () => {
	userRole.set([PERMISSIONS.WSHOP]);
	userRoleName.set("workshop");
	userName.set("Workshop Tester");
	navigate("/maintenance-repair");
};

export const doForgot = async ({ email }) => {
	try {
		errorMessage.set("");
		loading.set(true);
		const res = await api("/v1/auth/forgot-password", "User", "POST", {
			email,
		});
		if (res.status === 200) {
			loading.set(false);
			successMessage.set(
				`An email with a password reset link has been sent to you at ${email}`
			);
		} else {
			loading.set(false);
			errorMessage.set(res.data.errorMsg);
		}
	} catch (err) {
		loading.set(false);
		errorMessage.set(err.response.errors);
	}
};

export const doReset = async ({ testToken, password }) => {
	try {
		errorMessage.set("");
		loading.set(true);
		const res = await api(
			"/v1/auth/reset-password",
			"User",
			"POST",
			{
				newPassword: password,
			},
			{},
			testToken
		);
		if (res.status === 200) {
			successMessage.set("Password reset successfully");
			errorMessage.set("");
			loading.set(false);
		} else {
			errorMessage.set(res.data.errorMsg);
			loading.set(false);
		}
	} catch (err) {
		errorMessage.set(err.response.errors);
		loading.set(false);
	}
};

export const rehydrateToken = () => {
	let logToken;
	let refToken;
	logToken = localStorage.getItem("token");
	refToken = localStorage.getItem("refreshToken");
	token.set(logToken);
	refreshToken.set(refToken);
};
